import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavComponent } from './nav/nav.component';
import { FooterComponent } from './footer/footer.component';
import { LayoutComponent } from './layout.component';
import { RouterModule } from '@angular/router';
import { PlayerComponent } from './player/player.component';
import { ButtonChatComponent } from './button-chat/button-chat.component';
import { ButtonUpComponent } from './button-up/button-up.component';

const components = [
  LayoutComponent,
  NavComponent,
  FooterComponent,
  PlayerComponent,
  ButtonChatComponent,
  ButtonUpComponent,
]

@NgModule({
  declarations: [ components, ],
  exports: [ components ],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class LayoutModule { }
